import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();
import { ITransport } from "./ITransport";
import { ITransportSvc,transport_api } from "./ITransportSvc"


export class TransportSvc implements ITransportSvc {

    public async calc_koszty(transport:ITransport): Promise<ITransport|undefined> {
        const ret = await bus.api(transport_api.calc_koszty,transport);
        if (ret && ret._id) return (<ITransport> ret);
        else return undefined
    }

    public async get_lista_kodow_pocztowych(obj:any):Promise<string[]|undefined> {
        const ret = await bus.api(transport_api.update,obj); // obj.finder
        if (ret) return (<string[]> ret);
        else return undefined
    }

    public async update(transport: ITransport): Promise<ITransport | undefined> {
        const ret = await bus.api(transport_api.update,transport);
        if (ret && ret._id) return (<ITransport> ret);
        else return undefined
    }

    public async find_by_id(_id: any): Promise<ITransport | undefined> {
        const ret = await bus.api(transport_api.find_by_id,{_id:_id});
        console.log(ret)
        if (ret && ret._id) {
            return (<ITransport> ret);
        }
        else return undefined
    }

}
      